<form id="office_form" name="office_form" target="office_frame" [action]="officeActionUrl" method="post">
    <input name="access_token" [value]="accessTokenValue" type="hidden" />
    <input name="access_token_ttl" [value]="accessTokenTTLValue" type="hidden" />
</form>

<span id="frameholder"></span>
